import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRequiredCurrentUser } from 'FrontRoyalAngular';
import { useUpdatePreference } from '../useUpdatePreference';
import { PreferenceSwitchRow } from './PreferenceSwitchRow';

// Minimal port of the old edit-notifications directive: only the community-notifications
// preference is reachable in the UI today, so we render just that single switch. It's
// gated on the same conditions as before (messaging enabled + a Sendbird access token).
export function NotificationPreferences() {
    const { t } = useTranslation('back_royal');
    const currentUser = useRequiredCurrentUser();
    const updatePreference = useUpdatePreference();
    const [allowCommunityNotifications, setAllowCommunityNotifications] = useState(
        currentUser.prefAllowCommunityNotifications,
    );

    if (!(currentUser.messagingEnabled && currentUser.sendbirdAccessToken)) return null;

    const handleChange = (value: boolean) => {
        const previousValue = allowCommunityNotifications;
        setAllowCommunityNotifications(value);
        updatePreference({
            field: 'pref_allow_community_notifications',
            value,
            successContent: t('settings.edit_notifications.update_account_success', {
                title: t('settings.edit_notifications.pref_allow_community_notifications'),
            }),
            failureContent: t('settings.edit_preferences.update_preference_failure'),
        }).catch(() => setAllowCommunityNotifications(previousValue));
    };

    return (
        <PreferenceSwitchRow
            name="pref_allow_community_notifications"
            title={t('settings.edit_notifications.pref_allow_community_notifications')}
            description={t('settings.edit_notifications.pref_allow_community_notifications_desc')}
            isSelected={allowCommunityNotifications}
            onValueChange={handleChange}
        />
    );
}
